import { Box, BoxProps } from './Box'
import { Color } from '../constants'

export type CircleProps = BoxProps & {
  backgroundColor: Color
  children?: React.ReactNode
  size: number
}

/**
 * @deprecated
 */
export const Circle = (props: CircleProps) => {
  return (
    <Box
      {...props}
      alignItems="center"
      borderRadius={999}
      flexShrink={0}
      justifyContent="center"
    />
  )
}
